import { Route } from 'react-router-dom';

import { Notifications } from './notifications/notifications.component';
import { ContentDetail } from './templates/content-detail/content-detail.component';
import { TemplateDetail } from './templates/template-detail/template-detail.component';
import { Templates } from './templates/templates.component';

export function ApplicationsNotificationsRoutes() {
    return (
        <Route path='notifications'>
            <Route
                path='notifications'
                element={<Notifications />}
            />
            <Route path='templates'>
                <Route
                    index
                    element={<Templates />}
                />
                <Route path=':templateId'>
                    <Route
                        path='details'
                        element={<TemplateDetail />}
                    />
                    <Route path='content'>
                        <Route path=':contentId'>
                            <Route
                                path='details'
                                element={<ContentDetail />}
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Route>
    );
}
